import { useMeQuery, useTicketsQuery } from '#/api/api.portal';
import Loader from '#/components/Loader/Loader';
import { TicketHeader } from '#/screens/support/TicketHeader';
import { Link } from '@react-navigation/native';
import cx from 'classnames';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import styles from './Support.module.scss';

export const TicketList = () => {
  const { data: tickets, isLoading } = useTicketsQuery({ updateDate: true });
  const { data: profile, refetch: refetchProfile } = useMeQuery();
  const [updatedDates, setUpdatedDates] = useState(false);

  useEffect(() => {
    if (!tickets || !profile || updatedDates) {
      return;
    }

    const date = dayjs(profile.lastSeenTicketsAt || new Date());

    if (tickets.some(t => date.isBefore(t.updatedAt))) {
      setUpdatedDates(true);
      refetchProfile();
    }
  }, [profile?.lastSeenTicketsAt, tickets, refetchProfile]);

  return (
    <>
      {isLoading && <Loader size="large" />}
      {tickets && (
        <div className={styles.ticketList}>
          {tickets.map(ticket => (
            <Link to={`/support/${ticket.id}`} key={ticket.id}>
              <div className={cx(styles.block, styles.hoverable, styles.highlighted)}>
                <TicketHeader ticket={ticket} />
                <div className={styles.ticketDescription}>{ticket.descriptionText}</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </>
  );
};
